// api/legal.ts
import { API_BASE, getAuthHeaders } from './config';

export type LegalDocType = 'TERMS' | 'PRIVACY';

export type LegalDocument = {
    id: number;
    doc_type: LegalDocType;
    version: string;
    published_at: string;
    requires_reaccept: boolean;
    locale: string;
    title: string;
    html: string;
    body_text: string | null;
};

export type LegalMeta = {
    id: number;
    version: string;
    published_at: string;
    locale: string;
    title: string;
};

export type PublishLegalPayload = {
    change: 'TERMS' | 'PRIVACY' | 'BOTH';
    version?: string;
    requires_reaccept?: boolean;
    terms?: {
        locale?: string;
        title?: string;
        html?: string;
        body_text?: string;
    };
    privacy?: {
        locale?: string;
        title?: string;
        html?: string;
        body_text?: string;
    };
};

export type PublishLegalResponse = {
    ok: boolean;
    terms: LegalMeta | null;
    privacy: LegalMeta | null;
};

/**
 * Pobierz najnowszy regulamin / politykę prywatności (z treścią HTML).
 * GET /legal/doc?type=TERMS|PRIVACY
 */
export async function fetchLatestLegalDoc(type: LegalDocType): Promise<LegalDocument> {
    const res = await fetch(`${API_BASE}/legal/doc?type=${encodeURIComponent(type)}`, {
        headers: getAuthHeaders(),
    });
    if (!res.ok) throw await res.json();
    return res.json();
}

/**
 * Pobierz dokument po ID (gdybyś chciał kiedyś użyć historii).
 * GET /legal/documents/:id
 */
export async function fetchLegalDocById(id: string | number): Promise<LegalDocument> {
    const res = await fetch(`${API_BASE}/legal/documents/${id}`, {
        headers: getAuthHeaders(),
    });
    if (!res.ok) throw await res.json();
    return res.json();
}

/**
 * Publikacja nowej wersji regulaminu / polityki.
 * POST /admin/legal/publish
 */
export async function publishLegal(payload: PublishLegalPayload): Promise<PublishLegalResponse> {
    const res = await fetch(`${API_BASE}/admin/legal/publish`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...getAuthHeaders(),
        },
        body: JSON.stringify(payload),
    });
    if (!res.ok) throw await res.json();
    return res.json();
}
